import './datepicker/datepicker-zh-CN.js';
import './datepicker/datepicker-zh-HK.js';
import './datepicker/datepicker-zh-TW.js';
import './parsley/zh_cn.extra.js';
import './parsley/zh_cn.js';
import './parsley/zh_tw.js';
import './languageformat/languageformat.js';
